var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"mt-5 w-50"},[_c('ResetPasswordForm',{on:{"submit":_vm.onSubmit},model:{value:(_vm.credentials),callback:function ($$v) {_vm.credentials=$$v},expression:"credentials"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }